var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReserver = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.752,
    height: 22,
    viewBox: "0 0 21.752 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reserver",
    transform: "translate(-592.748 -66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_41",
    "data-name": "Groupe 41",
    transform: "translate(394 14)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(205 69)",
    fill: "#5471a9",
    fontSize: 16,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")), /*#__PURE__*/React.createElement("g", {
    id: "_3596215",
    "data-name": 3596215,
    transform: "translate(199.248 54.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M.432,6.323A.432.432,0,0,1,0,5.891V4.162A2.164,2.164,0,0,1,2.162,2H3.891a.432.432,0,0,1,0,.865H2.162a1.3,1.3,0,0,0-1.3,1.3V5.891A.432.432,0,0,1,.432,6.323Z",
    transform: "translate(0 -2)",
    fill: "#5471a9",
    stroke: "#5471a9",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9",
    transform: "translate(16.429 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M22.891,6.323a.432.432,0,0,1-.432-.432V4.162a1.3,1.3,0,0,0-1.3-1.3H19.432a.432.432,0,1,1,0-.865h1.729a2.164,2.164,0,0,1,2.162,2.162V5.891A.432.432,0,0,1,22.891,6.323Z",
    transform: "translate(-19 -2)",
    fill: "#5471a9",
    stroke: "#5471a9",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10",
    "data-name": "Groupe 10",
    transform: "translate(0 11.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M3.891,21.323H2.162A2.164,2.164,0,0,1,0,19.162V17.432a.432.432,0,0,1,.865,0v1.729a1.3,1.3,0,0,0,1.3,1.3H3.891a.432.432,0,1,1,0,.865Z",
    transform: "translate(0 -17)",
    fill: "#5471a9",
    stroke: "#5471a9",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11",
    "data-name": "Groupe 11",
    transform: "translate(16.429 11.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M21.162,21.323H19.432a.432.432,0,1,1,0-.865h1.729a1.3,1.3,0,0,0,1.3-1.3V17.432a.432.432,0,0,1,.865,0v1.729A2.164,2.164,0,0,1,21.162,21.323Z",
    transform: "translate(-19 -17)",
    fill: "#5471a9",
    stroke: "#5471a9",
    strokeWidth: 1
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReserver, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reserver.2f127e9e.svg";
export { ForwardRef as ReactComponent };